
import React from "react";
import Box from "@mui/material/Box";
import _ from "lodash";
import SelectArrow from "assets/svgIcons/SelectArrowIcon";
import styled from "styled-components";
import { Loader } from "commonComponents/Loader/Loader";
import { useTranslation } from "react-i18next";

const NavbarSelectValue = styled.p`
  padding: 8px 12px 8px 8px;
  font-size: 14px;

  @media (max-width: 850px) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90px;
    padding: 2px 6px 2px 8px;
    font-size: 13px;
  }
`;

const SelectDownArrowWrapper = styled.span`
  padding-right: 10px;

  @media (max-width: 850px) {
    padding-right: 6px;
  }
`;

const CurrentTime = styled.p`
  color: #fff;
  font-size: 12px;
  background: #6b5c4b;
  padding: 0 15px;
  border-radius: 7px;
  border: 1px solid #fff;
  font-weight: bolder;
  letter-spacing: 0.9px;

  @media (max-width: 850px) {
    padding: 1px 10px;
    width: 117px;
    text-align: center;
    font-size: 10px;
  }
`;

export const SiteSelector = ({
    selectedSite,
    onClick,
    siteId,
    selectSite,
    time
}) => {
    const { t } = useTranslation();

    const selectSiteParentStyle = {
        display: {
            xs: "flex",
            md: "flex",
        },
        padding: "0 15px",
        borderRight:
            "1px solid #E5E5E5;",
        height: "100%",
        alignItems: "center",
        position: "relative",
        cursor: "pointer",
        background: "#fff",
        flexDirection: "column",
        gap: "1px",
        justifyContent: "center",
    };

    const selectSiteStyle = {
        border: "1px solid #666666",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        gap: "5px"
    };

    return (
        <Box sx={selectSiteParentStyle}>
            <Box sx={selectSiteStyle} onClick={onClick}>
                <NavbarSelectValue>
                    {selectedSite}
                </NavbarSelectValue>

                <SelectDownArrowWrapper>
                    <SelectArrow />
                </SelectDownArrowWrapper>
            </Box>

            {siteId !== null && !selectSite && time != null &&
                <CurrentTime>
                    {t("Time_on_site") + ": " + time}
                </CurrentTime>
            }
        </Box>
    );
};